import { render, staticRenderFns } from "./NewRadio.vue?vue&type=template&id=2073c211&scoped=true&"
import script from "./NewRadio.vue?vue&type=script&lang=js&"
export * from "./NewRadio.vue?vue&type=script&lang=js&"
import style0 from "./NewRadio.vue?vue&type=style&index=0&id=2073c211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073c211",
  null
  
)

export default component.exports